import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IShipmentSearch, IShipmentDetail, IShipmentUpdate, ILogistics } from "./shimentTypes";
import { ISettleParams } from "../public/publicService";


class ShipmentService {
    async page(searchVo: IShipmentSearch, config: object = {}) {
        const apiUrl = "/gtm/shipment/listPage";
        return await httpRequest.post<IPage<IShipmentDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/shipment/findByIdOrCode/${id}`;
        return await httpRequest.get<IShipmentDetail>(apiUrl);
    }
    async update(updateVo: IShipmentUpdate) {
        const apiUrl = "/gtm/shipment/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string) {
        const apiUrl = `/gtm/base/shipment/enableOrDisable/${id}/`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //查询物流进程
    async oneLog(shipmentCode: string) {
        const apiUrl = `/gtm/logistics/findByIdOrCode/${shipmentCode}`;
        return await httpRequest.get<ILogistics>(apiUrl);
    }
    //新增物流进程
    async insertLog(updateVo: ILogistics) {
        const apiUrl = "/gtm/logistics/insert";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //编辑物流进程
    async updateLog(updateVo: ILogistics) {
        const apiUrl = "/gtm/logistics/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //结算
    async settle(settleVo: ISettleParams) {
        const apiUrl = `/gtm/add/settle`;
        return await httpRequest.post<boolean>(apiUrl, settleVo);
    }

    //导出
    async export(searchVo: IShipmentSearch) {
        const appPageUrl = "/gtm/shipment/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/shipment/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    //转运输单据
    async transferInvoices(Vo: {
        shopCode: string,
        code: string
    }) {
        const apiUrl = `/gtm//shipment/transferInvoices`;
        return await httpRequest.post<string>(apiUrl, Vo);
    }
}

export const shipmentService = new ShipmentService();
